// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0a326d',       // dark navy — buttons, headers, sidebar
      light: '#5383b3',      // medium blue — AppBar, tab active
      lighter: '#85a5c6',    // pale blue — tab inactive
    },
    background: {
      default: '#d9d9d9',    // page background
    },
  },
  typography: {
    fontFamily: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,

    h1: {
      fontFamily: "'Syne', sans-serif",
      fontSize: '2rem',
      fontWeight: 800,
      letterSpacing: '-0.8px',
      lineHeight: 1.1,
    },
    h2: {
      fontFamily: "'Syne', sans-serif",
      fontSize: '1.65rem',
      fontWeight: 700,
      letterSpacing: '-0.4px',
      lineHeight: 1.2,
    },
    h3: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      fontSize: '1.35rem',
      fontWeight: 700,
      letterSpacing: '-0.2px',
      lineHeight: 1.25,
    },
    h4: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      fontSize: '1.15rem',
      fontWeight: 600,
      letterSpacing: '-0.1px',
      lineHeight: 1.3,
    },
    h5: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      fontSize: '1rem',
      fontWeight: 600,
      letterSpacing: '0',
      lineHeight: 1.35,
    },
    h6: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      fontSize: '0.9rem',
      fontWeight: 600,
      letterSpacing: '0',
      lineHeight: 1.4,
    },
    subtitle1: {
      fontSize: '0.875rem',
      fontWeight: 500,
      letterSpacing: '0.1px',
      lineHeight: 1.4,
    },
    subtitle2: {
      fontSize: '0.8125rem',
      fontWeight: 500,
      letterSpacing: '0.1px',
      lineHeight: 1.4,
    },
    body1: {
      fontSize: '0.875rem',
      fontWeight: 400,
      letterSpacing: '0',
      lineHeight: 1.55,
    },
    body2: {
      fontSize: '0.8125rem',
      fontWeight: 400,
      letterSpacing: '0',
      lineHeight: 1.5,
    },
    button: {
      fontSize: '0.8125rem',
      fontWeight: 700,
      letterSpacing: '0.5px',
      textTransform: 'uppercase',
    },
    caption: {
      fontSize: '0.6875rem',
      fontWeight: 500,
      letterSpacing: '0.8px',
      lineHeight: 1.3,
    },
    overline: {
      fontSize: '0.625rem',
      fontWeight: 700,
      letterSpacing: '1.2px',
      lineHeight: 1,
      textTransform: 'uppercase',
    },
  },
});

export default theme;
